import React from 'react';

import CliveAvatar from '~/core/iconComponents/special/CliveAvatar';

export const FnolHeader: React.FC = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-20">
      <CliveAvatar className="fill-none" size="2xl" />
      <h1 className="ml-20 text-2xl font-semibold text-slate-800">Let’s get started</h1>
      <span className="text-center text-base text-slate-700">
        To create a new claim, please add the incident description, Clive will analyze it, and create a draft claim
        based on the information you provide.
      </span>
    </div>
  );
};
